/* eslint-disable import/no-cycle */
import api from './api.service';

function getRegions(params) {
  return api.get('/regions/', params);
}
function getProvinces(regionId, params) {
  return api.get(`/regions/${regionId}/provinces`, params);
}

function getCities(regionId, provinceId, params) {
  return api.get(`/regions/${regionId}/provinces/${provinceId}/cities`, params);
}

function getZipCodes(regionId, provinceId, cityId, params) {
  return api.get(`/regions/${regionId}/provinces/${provinceId}/cities/${cityId}/zipcodes`, params);
}

export const citiesService = {
  getRegions,
  getProvinces,
  getCities,
  getZipCodes,
};
